
  import Events from '@/events/Events';
  import JobBoxAlert from '@/components/JobBoxAlert';
  import JobBoxWithTypesense from '@/mixins/JobBoxWithTypesense';

  export default {
    name: 'EventJobPostings',
    components: {
      Pagination: () => import('@/components/Pagination'),
      JobBoxAlert,
    },
    mixins: [JobBoxWithTypesense],
    props: {
      event: {
        type: Object,
        require: true,
        default: () => {},
      },
      numJobPostings: {
        type: Number,
        required: false,
        default: 5,
      },
    },
    data() {
      return {
        page: 1,
        jobPostings: [],
        jobAlertSearchRequestUrl: '',
      };
    },
    fetch() {
      this.jobAlertSearchRequestUrl =
        this.sectionFilterParams +
        '&order[order_number]=desc&itemsPerPage=16&page=1';
      this.jobAlertSearchRequestUrl = this.jobAlertSearchRequestUrl.replace(
        /&pagination=false/g,
        ''
      );
      if (!this.jobAlertSearchRequestUrl.includes('isPublished')) {
        this.jobAlertSearchRequestUrl += '&isPublished=1';
      }
    },
    computed: {
      visibleJobs() {
        const jobs = this.jobPostings.slice(
          (this.page - 1) * this.numJobPostings,
          this.page * this.numJobPostings
        );
        let items = [];
        if (process.client && jobs) {
          items = jobs.map((item, key) => ({
            id: item.id,
            position: key + 1,
          }));
          this.$emitWithClientData(Events.JobBoxViewed, {
            boxType: 'EventOffers',
            items,
          });
        }
        return jobs;
      },
    },
    mounted() {
      this.getJobPostings().catch((e) => {
        this.jobPostings = [];
        this.loading = false;

        throw e;
      });
    },
    created() {
      this.filterConfig.sectionFilterParams =
        this.sectionFilterParams === ''
          ? new URLSearchParams()
          : new URLSearchParams(this.sectionFilterParams);
      this.filterConfig.numJobPostings = this.numJobPostings * 5;
      this.filterConfig.shuffleAndSlice = this.numJobPostings * 5;
      this.filterConfig.sectionFilterParams = this.event.filterParams || {
        search: this.event.title,
      };
      this.filterConfig.sectionFilterParams.search = `"${
        this.filterConfig.sectionFilterParams.search || this.event.title
      }"`;
    },
    methods: {
      async getJobPostings() {
        this.filterConfig.getTopTeaserJobPostings = false;
        this.filterConfig.getInstantTeaserJobPostings = false;
        this.filterConfig.getHomepageTeaserJobPostings = false;

        await this.fetchJobPostings();

        this.jobPostings = this.mergedJobPostings;

        const items = this.jobPostings.map((item, key) => ({
          id: item.id,
          position: key + 1,
        }));

        this.$emitWithClientData(Events.JobBoxViewed, {
          boxType: 'EventOffers',
          items,
        });
      },
    },
  };
